import {InputProps, Stack, useTheme} from "@mui/joy";

const Input = (props: InputProps) => {
    const theme = useTheme()
    // Kept out of the spread below: it is rendered beside the field, not forwarded to the DOM input
    const {endDecorator, ...inputProps} = props

    return <Stack direction={"row"} alignItems={"center"}
                  sx={{
                      border: "3px solid transparent",
                      borderRadius: "13px",
                      outline: "none",
                      overflow: "hidden",
                      background: `linear-gradient(${theme.palette.primary[50]},
                      ${theme.palette.primary[50]}) padding-box, linear-gradient(45deg, ${theme.palette.primary[700]}, #2DDF82) border-box`,
                  }}>
        {/*@ts-ignore*/}
        <input
            {...inputProps}
            style={{
                color: "white",
                width: "100%",
                padding: "20px",
                background: "transparent",
                border: "none",
                fontSize: 15
            }}
        />

        {endDecorator && <Stack paddingX={1}>
            {endDecorator}
        </Stack>}
    </Stack>

}

export default Input
